/**
 * Version utilities for Portfolio Wizard
 * Automatically updated during build process
 */

import packageJson from '../../package.json';

export interface VersionInfo {
  version: string;
  buildDate: string;
  commitHash: string;
  environment: string;
}

// Version info injected at build time via Vite environment variables
export const getVersionInfo = (): VersionInfo => {
  return {
    version: packageJson.version,
    buildDate: import.meta.env.VITE_BUILD_DATE || __BUILD_DATE__ || new Date().toISOString(),
    commitHash: import.meta.env.VITE_COMMIT_HASH || __COMMIT_HASH__ || 'unknown',
    environment: import.meta.env.MODE || 'development'
  };
};

// Format version for display
export const getDisplayVersion = (): string => {
  const info = getVersionInfo();
  const isProduction = info.environment === 'production';
  
  if (isProduction) {
    return `v${info.version}`;
  } else {
    return `v${info.version} BETA`;
  }
};

// Get detailed version info for debugging
export const getDetailedVersionInfo = (): string => {
  const info = getVersionInfo();
  const buildDate = new Date(info.buildDate);
  const shortHash = info.commitHash.substring(0, 7);
  
  return [
    `Version: ${info.version}`,
    `Build: ${buildDate.toLocaleDateString('de-DE')} ${buildDate.toLocaleTimeString('de-DE')}`,
    `Commit: ${shortHash}`,
    `Environment: ${info.environment}`
  ].join(' • ');
};
